import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GridApi, GridOptions } from 'ag-grid-community';
import { Animal } from 'src/app/core/models/animal';
import { AgGridClickableCellComponent } from '../../components/ag-grid-clickable-cell/ag-grid-clickable-cell.component';

import { UtilService } from 'src/app/core/services/util.service';
import { Subscription, Observable, of, BehaviorSubject } from 'rxjs';
import { Utils } from 'src/app/core/utils/util';
import * as _moment from 'moment';
import { difference, update } from 'lodash';

const moment = _moment;

export interface DialogData {
  animal: Animal;
  selectedTraining?:any[];
  animalTrainingList:any[];
}

@Component({
  selector: 'app-animal-training',
  templateUrl: './animal-training.component.html',
  styleUrls: ['./animal-training.component.scss']
})

export class AnimalTrainingComponent implements OnInit {
  animalTrainingGridApi: GridApi;
  public gridOptions = {
    context: {
      componentParent: this,
    },
    suppressHorizontalScroll: false,
    rowStyle: { background: 'white' }
  } as GridOptions;
  defaultColDef: any;
  frameworkComponents;
  getRowHeight: any;
  headerHeight: any;
  columnDefs: any[] = [];
  rowsCreated:boolean=false;
  trainingRowData: BehaviorSubject<Array<any[]>>;
  subs: Array<Subscription> = [];
  rowsDeleted:boolean=false;
  deleteIds:any[]=[];

  trainingForm: FormGroup;
  
  constructor(public dialogRef: MatDialogRef<AnimalTrainingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,private utilService:UtilService) {
      this.getRowHeight = (params) => {
        return 34;
      }
      this.headerHeight = 34;
    }

  ngOnInit(): void {
    this.initTrainingForm();
    this.getMasterData();
    this.setupAnimalTrainingGridColumn();
  }

  initTrainingForm() {
    this.trainingForm = this.fb.group({
                                      training_value: [''],
                                      start_date: ['',[Validators.required]],
                                      end_date: [''],
                                  }, {validator: this.dateLessThan('start_date','end_date')});
  }

  dateLessThan(from:string,to:string) {
    return (group: FormGroup): {[key: string]: any} => {
      let f = group.controls[from].value;
      let t = group.controls[to].value;
      if((f !== '' && t !== ''))
      {
        return (f <= t) ? null : { range: true };
      }     
    }
 }
 getMasterData() {
  if(this.data.selectedTraining && this.data.selectedTraining.length > 0) {
      this.trainingRowData = new BehaviorSubject<any[]>([]);
      this.trainingRowData.next(this.data.selectedTraining);
    }
  }

  setupAnimalTrainingGridColumn() {
    this.defaultColDef = Utils.getBaseThemeAgGridCol();
    this.columnDefs = [
      {
        headerName: '',
        field: 'check',
        headerCheckboxSelection: true,
        checkboxSelection: true,
        suppressSizeToFit: true,
        sortable: false,
        resizable: false,
        filter: false,
        minWidth: 10,
        width: 31,
        cellStyle: {
          ...this.defaultColDef.cellStyle,
          display: 'flex',
          justifyContent: 'center',
          padding: '0 0 0 10px'
        },
      },
      {
        headerName: 'Date',
        field: 'routine_date',
        cellStyle: {
          ...this.defaultColDef.cellStyle,
          justifyContent: 'center'
        },
        filter: 'agDateColumnFilter',
        filterParams: Utils.dateFilterParams()
      },
      {
        headerName: 'Training',
        field: 'training_value',
        cellStyle: {
          ...this.defaultColDef.cellStyle,
          justifyContent: 'flex-start'
        },
        filterParams: Utils.filterParams(),
      },
      
    ];
  }
  
  onTrainingGridReady(params) {
    this.animalTrainingGridApi = params.api;
    this.animalTrainingGridApi.sizeColumnsToFit();
    if(this.data.selectedTraining.length == 0 || !this.data.selectedTraining)
      this.trainingRowData = new BehaviorSubject<any[]>([]);
  }

  trainingScheduleList(): Array<any> {
    let trainingList: any[] = [];
    let startDate: _moment.Moment = moment(this.trainingForm.get('start_date').value, 'MM/DD/YYYY');
    let endDate: _moment.Moment = moment(this.trainingForm.get('end_date').value, 'MM/DD/YYYY');
    for (let index = 0; index <= endDate.diff(startDate, 'days'); index++) {
      let tempDate: _moment.Moment = moment(this.trainingForm.get('start_date').value, 'MM/DD/YYYY');

     
        let trainingPayload = {
                          training_id: Utils.getUUIDv4(),
                          training_value: this.trainingForm.get('training_value').value,
                          routine_date: tempDate.add(index, 'days').format('MM/DD/YYYY'),
                        };
                        trainingList.push(trainingPayload);
    }
    return trainingList;
  }
    
  onRemoveSelectedTraining() {
    let selectedTrainingRows: any[] = this.animalTrainingGridApi.getSelectedRows();
    let allTraining: any[] = this.trainingRowData.getValue();
    
    let filteredTraining = allTraining.filter(tra => {
      this.rowsDeleted=true;
      let findIndexVal=selectedTrainingRows.findIndex(ele => ele.training_id == tra.training_id);
      if(findIndexVal == -1){
        return findIndexVal;
      }else if(Number(tra.training_id)){
        (tra.training_id) ? this.deleteIds.push(tra.training_id) : '';
      }
      //return selectedMedication.findIndex(ele => ele.medical_id == med.medical_id) == -1;
    });
    this.trainingRowData.next(filteredTraining);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSaveClicked() {
    let trainingResult={
      "delete":this.deleteIds,
      "update":this.trainingRowData.getValue()
    }
    this.dialogRef.close(trainingResult);
  }
  
  onCreateClicked() {
    if(this.trainingForm.invalid){
      this.trainingForm.markAllAsTouched();
      return;
    }
    
      let trainingList: any[] = this.trainingRowData.getValue();
      trainingList = [...trainingList, ...this.trainingScheduleList()];
      this.trainingRowData.next(trainingList);
      this.rowsCreated=true;
    }

  isdisableCheck(){  
    if(this.trainingRowData){
     
      let trainingList: any[] = this.trainingRowData.getValue();
      if(this.rowsDeleted || (trainingList.length > 0 && this.rowsCreated))
          return false;
      else
          return true;
    }else
       return true;
  }
}